import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow
} from "@fluentui/react-components";
import {useOutletContext, useParams} from "react-router-dom";
import {Button} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import {ContactPage} from "@mui/icons-material";

function ChildrenDocument() {

    const {children} = useOutletContext();
    const params = useParams();
    const [user] = useContext(AuthContext);
    const [documents, setDocuments] = useState([]);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children/${children}/document/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setDocuments(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [children, refresh]);


    const columns = [
        createTableColumn ({
            columnId: "timestamp",
            compare: (a, b) => {
                return a.timestamp.localeCompare(b.timestamp);
            },
            renderHeaderCell: () => {
                return "Umieszczono";
            },
            renderCell: (item) => item.timestamp
        }),
        createTableColumn ({
            columnId: "more",
            renderHeaderCell: () => {
                return 'Podgląd';
            },
            renderCell: (item) => {
                return <Button target={'_blank'} href={`/api/children/document/${item.id}?auth=${user.token}`} variant={'contained'} color={'info'}><ContactPage /></Button>
            }
        }),
    ];

    return (
        <DataGrid
            items={documents}
            columns={columns}
            sortable
            getRowId={(item) => item.id}
            focusMode="composite"
            style={{flexGrow: 1, maxWidth: '60vw'}}
        >
            <DataGridHeader>
                <DataGridRow>
                    {({renderHeaderCell}) => (
                        <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody>
                {({item, rowId}) => (
                    <DataGridRow key={rowId}>
                        {({renderCell}) => (
                            <DataGridCell>{renderCell(item)}</DataGridCell>
                        )}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
    );
}

export default ChildrenDocument;